export const CATEGORY_STYLES = {
  verfahrensanweisung: 'bg-blue-100 text-blue-700 border-blue-200',
  formular: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  audit: 'bg-violet-100 text-violet-700 border-violet-200',
  korrekturmassnahme: 'bg-red-100 text-red-700 border-red-200',
  info: 'bg-gray-100 text-gray-700 border-gray-200',
};

export const fmtDate = (iso) => {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
  } catch {
    return iso;
  }
};
